import script from "./KPIsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIsTab.vue?vue&type=script&setup=true&lang=js"

import "./KPIsTab.vue?vue&type=style&index=0&id=6810e556&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6810e556"]])

export default __exports__